import { render } from "./animationBlock.vue?vue&type=template&id=44f5a191"
import script from "./animationBlock.vue?vue&type=script&lang=js"
export * from "./animationBlock.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__